import i18n, { AVAILABLE_LOCALES } from '@/i18n'

const formatLargeNumber = (number?: number, useThousandsSeparator = false): string => {
  const locale = i18n.language
  if (typeof number === 'undefined') return ''

  if (number >= 10000) {
    if (locale === AVAILABLE_LOCALES.TW || locale === AVAILABLE_LOCALES.CN) {
      const tenThousandValue = Math.round((number / 10000) * 10) / 10
      return `${useThousandsSeparator ? new Intl.NumberFormat(locale).format(tenThousandValue) : tenThousandValue}万`
    } else if (locale === AVAILABLE_LOCALES.EN) {
      const thousandValue = Math.round((number / 1000) * 10) / 10
      return `${useThousandsSeparator ? new Intl.NumberFormat(locale).format(thousandValue) : thousandValue}k`
    }
  }

  return useThousandsSeparator ? new Intl.NumberFormat(locale).format(number) : number.toString()
}

const formatNumberWithCaps = (number?: number): string => {
  if (typeof number === 'undefined') return ''

  const locale = i18n.language
  const isChinese = locale === AVAILABLE_LOCALES.TW || locale === AVAILABLE_LOCALES.CN

  if (isChinese) {
    if (number >= 100000) return '10万+'
    if (number >= 10000) return `${Math.floor(number / 10000)}万+`
    if (number >= 1000) return `${Math.floor(number / 1000)}千+`
  } else {
    if (number >= 1000000) return `1M+`
    if (number >= 1000) return `${Math.floor(number / 1000)}K+`
  }

  return number.toString()
}

export { formatLargeNumber, formatNumberWithCaps }
